import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "../Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <a href="/" className="logo logo-light" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
            <div style={{
              width: 28,
              height: 28,
              borderRadius: 4,
              background: "#003366",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}>
              <i className="mdi mdi-chart-box-outline" style={{ color: "#fff", fontSize: 16 }}></i>
            </div>
            <div className="erp-brand-label">
              <div className="erp-brand-name">LS-DA</div>
              <div className="erp-brand-sub">Portal Administrativo</div>
            </div>
          </a>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {},
)(withRouter(withTranslation()(Sidebar)))
